export default __webpack_public_path__ + "static/media/leader_notes.96bd48d9.pdf";